import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { ValueProp } from './components/ValueProp';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Process } from './components/Process';
import { Trust } from './components/Trust';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyWhatsApp } from './components/StickyWhatsApp';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-brand-accent/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problem data-id="element-4" />
        <ValueProp data-id="element-5" />
        <Services data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <Process data-id="element-8" />
        <Trust data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <StickyWhatsApp data-id="element-13" />
    </div>;
}